module.exports = {"id":"177519","name":"Serdar Tasci","rating":"79","photo":"./data/images/photos/0/177519.png","club":{"name":"Spartak Moscou","logo":"./data/images/clubs/SpartakMoscou.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SerdarTasci0.json
// module id = 3895
// module chunks = 0